import React from 'react';
import {WideHeader} from '../../layout/wide';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <WideHeader
        title="Polityka Prywatności"
        introduction="Privacy Policy for Baza Witraży Service"
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="text-gray-700 leading-relaxed space-y-6">
              <div>
                <h2 className="text-2xl font-cinzel font-bold text-gray-900 mb-4">
                  Polityka Prywatności Serwisu „Baza Witraży"
                </h2>
                <p>
                  Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych Użytkowników 
                  korzystających z serwisu internetowego „Baza Witraży", prowadzonego w ramach działalności Corpus Vitrearum Polska.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  1. Administrator Danych Osobowych
                </h3>
                <p className="mb-3">
                  Administratorem Twoich danych osobowych jest <strong>Corpus Vitrearum Polska</strong> z siedzibą 
                  w Krakowie, ul. Grodzka 53, 31–001 Kraków.
                </p>
                <p>
                  W sprawach związanych z przetwarzaniem Twoich danych możesz skontaktować się z nami pod adresem 
                  e-mail: <a href="mailto:cvp@uj.edu.pl" className="text-blue-600 hover:underline">cvp@uj.edu.pl</a>.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  2. Cele i Podstawy Prawne Przetwarzania Danych
                </h3>
                <p className="mb-3">Przetwarzamy Twoje dane osobowe w następujących celach:</p>
                
                <ol className="list-decimal pl-6 space-y-4">
                  <li>
                    <strong>Świadczenia usług drogą elektroniczną</strong> – w tym zakładania i zarządzania kontem 
                    Użytkownika, umożliwienia zapisywania ulubionych witraży i tworzenia własnych kolekcji.
                    <ul className="list-disc pl-6 mt-2">
                      <li><em>Podstawa prawna:</em> Niezbędność do wykonania umowy o świadczenie usług (art. 6 ust. 1 lit. b RODO).</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Obsługi zapytań e-mail</strong> – w przypadku skorzystania z formularza kontaktowego, 
                    dane są przetwarzane w celu udzielenia odpowiedzi na Twoją wiadomość.
                    <ul className="list-disc pl-6 mt-2">
                      <li><em>Podstawa prawna:</em> Prawnie uzasadniony interes Administratora (art. 6 ust. 1 lit. f RODO), 
                      polegający na obsłudze korespondencji.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Zapewnienia bezpieczeństwa serwisu</strong> – w tym do ochrony formularzy przed spamem 
                    i automatycznymi działaniami (botami) przy użyciu usługi Google reCAPTCHA.
                    <ul className="list-disc pl-6 mt-2">
                      <li><em>Podstawa prawna:</em> Prawnie uzasadniony interes Administratora (art. 6 ust. 1 lit. f RODO), 
                      polegający na zabezpieczeniu serwisu.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Celów analitycznych i statystycznych</strong> – aby lepiej zrozumieć, w jaki sposób 
                    Użytkownicy korzystają z serwisu i móc go ulepszać (za pomocą Google Analytics).
                    <ul className="list-disc pl-6 mt-2">
                      <li><em>Podstawa prawna:</em> Twoja dobrowolna zgoda (art. 6 ust. 1 lit. a RODO), wyrażona za 
                      pośrednictwem baneru cookies.</li>
                    </ul>
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  3. Technologie Przechowywania Danych (Pliki Cookie i Podobne)
                </h3>
                <p className="mb-3">
                  Serwis korzysta z plików cookie oraz innych technologii przechowywania lokalnego (takich jak <code className="bg-gray-100 px-1 py-0.5 rounded">localStorage</code>) 
                  w celu zapewnienia jego prawidłowego funkcjonowania.
                </p>

                <ol className="list-decimal pl-6 space-y-4">
                  <li>
                    <strong>Technologie Niezbędne:</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Są kluczowe dla działania serwisu. Używamy ich do utrzymania Twojej sesji po zalogowaniu 
                      (abyś nie musiał logować się na każdej podstronie) oraz do zapisywania Twoich preferencji 
                      dotyczących wyświetlania serwisu i wyników wyszukiwania.</li>
                      <li>Technologie te nie wymagają zgody, ponieważ są niezbędne do świadczenia usługi.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Technologie Analityczne (Google Analytics):</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Używamy ich tylko i wyłącznie za Twoją zgodą.</li>
                      <li>Służą do zbierania anonimowych danych statystycznych o sposobie korzystania z serwisu. 
                      Pomaga nam to rozwijać „Bazę Witraży".</li>
                      <li>Zgoda ta może być w każdej chwili wycofana poprzez zmianę ustawień w banerze cookies.</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Technologie Bezpieczeństwa (Google reCAPTCHA):</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Usługa Google reCAPTCHA jest używana w formularzach (np. kontaktowym, rejestracji) do 
                      weryfikacji, czy dane nie są wprowadzane przez bota. Działa ona w oparciu o nasz prawnie 
                      uzasadniony interes.</li>
                      <li>Korzystanie z reCAPTCHA podlega Polityce Prywatności i Warunkom Świadczenia Usług Google.</li>
                    </ul>
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  4. Zakres i Odbiorcy Danych
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>W celu założenia konta, wymagamy podania adresu e-mail. Przechowujemy również dane dotyczące 
                  Twoich zapisanych kolekcji i ulubionych obiektów.</li>
                  <li>Podczas kontaktu e-mail przetwarzamy Twój adres e-mail oraz treść wiadomości.</li>
                  <li>
                    Twoje dane mogą być powierzane podmiotom zewnętrznym, które wspierają nas w świadczeniu usług. Są to:
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Dostawca usług hostingowych dla serwisu.</li>
                      <li>Google Ireland Ltd. – w zakresie usług Google Analytics (jeśli wyrazisz zgodę) oraz Google reCAPTCHA.</li>
                    </ul>
                  </li>
                </ol>
                <p className="mt-3">
                  Ze względu na korzystanie z usług Google, Twoje dane (w przypadku Analytics i reCAPTCHA) mogą być 
                  transferowane poza Europejski Obszar Gospodarczy (EOG) na zasadach określonych przez Google 
                  (zwykle Standardowe Klauzule Umowne).
                </p>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  5. Okres Przechowywania Danych
                </h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Dane Twojego konta (w tym kolekcje i ulubione) przechowujemy przez cały okres jego posiadania, 
                  aż do momentu jego usunięcia przez Ciebie lub Administratora.</li>
                  <li>Dane z korespondencji e-mail przechowujemy przez czas niezbędny do realizacji zapytania.</li>
                  <li>Dane analityczne (zebrane za Twoją zgodą) przechowujemy przez okres wskazany w ustawieniach 
                  Google Analytics (np. 26 miesięcy).</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  6. Twoje Prawa (Prawa RODO)
                </h3>
                <p className="mb-3">
                  W związku z przetwarzaniem Twoich danych, przysługują Ci następujące prawa:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Prawo dostępu do swoich danych.</li>
                  <li>Prawo do sprostowania (poprawienia) danych.</li>
                  <li>Prawo do usunięcia danych (tzw. „prawo do bycia zapomnianym").</li>
                  <li>Prawo do ograniczenia przetwarzania danych.</li>
                  <li>Prawo do wniesienia sprzeciwu wobec przetwarzania (gdy odbywa się na podstawie naszego 
                  uzasadnionego interesu).</li>
                  <li><strong>Prawo do wycofania zgody</strong> (w przypadku danych analitycznych) w dowolnym momencie, 
                  bez wpływu na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem.</li>
                  <li>Prawo do przenoszenia danych (jeśli przetwarzanie odbywa się na podstawie umowy lub zgody).</li>
                  <li>Prawo do wniesienia skargi do organu nadzorczego (Prezesa Urzędu Ochrony Danych Osobowych).</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  7. Postanowienia Końcowe
                </h3>
                <p>
                  Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej Polityce Prywatności. O wszelkich 
                  zmianach będziemy informować na stronach serwisu.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;

